import { Navigate } from 'react-router-dom';
import Loader from '../Shared/Loader';
import { useSaasSession } from '../../saas/SessionContext';

export default function ForcePasswordChangeRoute({ children }) {
  const { loading, user } = useSaasSession();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.forcePasswordChange) return <Navigate to={user.platformRole === 'platform_admin' ? '/platform-admin' : '/'} replace />;
  return children;
}
